import {
  DEFAULT_MAX_ZOOM_LEVEL,
  DEFAULT_ZOOM_LEVEL,
  EUROPE_GEOGRAPHICAL_CENTER_COORDINATES,
  GOOGLE_MAP_STYLES
} from '@constants/google-maps/google-maps.constant';

export class DashboardMapProperties {
  map: google.maps.Map | undefined;
  markers: google.maps.Marker[] = [];
  options: google.maps.MapOptions = {
    mapTypeId: google.maps.MapTypeId?.ROADMAP,
    zoom: DEFAULT_ZOOM_LEVEL,
    maxZoom: DEFAULT_MAX_ZOOM_LEVEL,
    center: EUROPE_GEOGRAPHICAL_CENTER_COORDINATES,
    streetViewControl: false,
    fullscreenControl: false,
    styles: GOOGLE_MAP_STYLES
  };
}
